<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Ny budgivare</p>
    </div>
    <div class="modal-content">
      <div class="grid2col grid2col--21">
        <div>
          <select v-model="chosenCustomer">
            <option disabled value="">Välj intressent</option>
            <option v-for="(stakeholder, index) in stakeHolders" :key="index" :value="stakeholder">
              {{ stakeholder.persons }}
            </option>
          </select>
        </div>
        <button class="p5" @click="addCustomer">
          lägg till
        </button>
      </div>

      <p class="all-caps mt-20 mb-15">Valda budgivare</p>
      <p class="fg-grey mt-10" v-if="!allChosenCustomers.length">Inga valda budgivare...</p>
      <ul v-show="allChosenCustomers">
        <li class="grid2col grid2col--icon-row mb-15" v-for="(customer, index) in allChosenCustomers" :key="index">
          <div>{{ customer.persons }}</div>
          <div class="text-right"><img @click="remove(index)" alt="icon" src="@/assets/icons/remove.svg"></div>
        </li>
      </ul>

      <div class="animate__animated" v-bind:class="{ visibility_hidden: !allChosenCustomers.length }">
        <input type="text" inputmode="numeric" class="width-100" @input="priceFormatted(bid)" v-model="bid" placeholder="Bud">
        <div class="grid2col mt-15 mb-25">
          <div><input type="date" v-model="date" class="width-100"></div>
          <div><input type="time" v-model="time" class="width-100"></div>
        </div>

        <div class="flex align-middle mb-15">
          <label class="switch mr-10" style="width: 33px;">
            <input type="checkbox" class="mr-5" v-model="confirmedForPublish">
            <div class="slider round"></div>
          </label>
          <span class="pl-15">Godkänd för publicering</span>
        </div>
        <div class="flex align-middle">
          <label class="switch mr-10 width-50">
            <input type="checkbox" class="mr-5" v-model="bidVisibleInternet">
            <div class="slider round"></div>
          </label>
          <span class="pl-15">Detta är ett dolt bud som inte är godkänt att publicera på internet.</span>
        </div>

        <input type="text" placeholder="Budlista kommentar" v-model="bidListComment" class="mt-25 width-100">
        <input type="text" placeholder="Intern kommentar" v-model="internalComment" class="mt-15 width-100">
      </div>
    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Bugsnag from '@bugsnag/js';

export default {
  name: 'newBidder',
  data(){
    return {
      chosenCustomer: [],
      allChosenCustomers: [],
      date: new Date().toISOString().slice(0, 10),
      time: new Date().toLocaleTimeString().slice(0, 5),
      bidVisibleInternet: false,
      bid: '',
      bidListComment: '',
      internalComment: '',
      confirmedForPublish: true
    }
  },
  computed: {
    /**
     * { stakeHolderGroupIds: [xxx, yyy], persons: "nisse bosse, anna annasson ... "}
     */
    stakeHolders() {
      return this.$store.getters.getStakeholders;
    }
  },
  methods: {
    priceFormatted(bid) {
      let aux = parseInt(bid.replace(/ /g, ''));
      if (aux > 0) {
        this.bid = this.$root.formatPrice(aux);
      }
    },
    addCustomer() {
      this.allChosenCustomers.push(this.chosenCustomer);
      this.chosenCustomer = [];
    },
    remove(index) {
      this.allChosenCustomers.splice(index, 1);
    },
    abort() {
      this.$root.modalOpen = false;
    },
    resetBidForm() {
      this.bid = "";
      this.allChosenCustomers = [];
    },
    save() {
      // create array with only stakeholderGroupCustomerIds to send
      let chosenCustomersIdsOnly = [];
      this.allChosenCustomers.forEach((i) => {
        i.stakeHolderGroupCustomersIds.forEach((y) => {
          chosenCustomersIdsOnly.push(y);
        });
      });

      // this.bid formatted by formatPrice so we create new
      let amount = this.bid.replace(/\s+/g, '');
      let data = {
        objectId: this.$route.params.id,
        customers: chosenCustomersIdsOnly,
        amount: amount,
        hide: this.bidVisibleInternet ? 1 : 0,
        date: this.date + ' ' + this.time + ":00", // leading seconds required
        comment: this.bidListComment,
        commentInternal: this.internalComment,
        confirmedForPublish : this.confirmedForPublish ? 1 : 0
      }

      if (!data.customers.length) {
        alert("Fel: Ingen kund vald!");
        return;
      }

      this.$root.callFasAdApi("/internalapi/bid/create-bid-and-bid-identity", "POST", data)
      .then((data) => {
        this.$root.handleResponseMessage(data);
        // refresh data
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
        // reset the bid form
        this.resetBidForm();
        this.$root.modalOpen = false;

        let notifyThesePeople = this.$store.getters.notifyThesePeople;

        // Sometimes (unknown why) this ends up with no results, so this is extra precaution
        // ref: https://prek.myjetbrains.com/youtrack/issue/FG-5
        if (!notifyThesePeople.length) {
          notifyThesePeople = this.$store.getters.getAllStakeHolders;
        }

        // notifyThesePeople was empty, and still empty once calling getAllStakeHolders, this should *really* not be possible.
        if (!notifyThesePeople.length) {
          Bugsnag.notify("notifyThesePeople and getAllStakeHolders both failed from newBidder. ObjectId: " + this.$route.params.id);
        }

        // we call action below to provide messagemodal with reciepiants data
        this.$store.dispatch('storeContactDataAfterNewBidder', {
          receivers: notifyThesePeople,
          objectId: this.$route.params.id
        });
        // now we can trigger the send message modal
        this.$emit('submitted', { component: "sendSmsOrMail" });
      })
      .catch(console.error);
    }
  }
}
</script>